/**
 * Convert a string into a slug
 * Example: Real Madrid => real-madrid
 * @param text
 * @returns string
 */
export const slugify = (text: string): string =>
  text
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-');

/**
 * Convert a string into a slug
 * Example 1: 4213 => 4-2-1-3
 * Example 2: Real Madrid => r-e-a-l-m-a-d-r-i-d
 * @param text
 * @returns string
 */
export const slugifyCharacters = (text: string): string =>
  text.toLowerCase().trim().replace(/\s+/g, '').split('').join('-');

/**
 * Coverts a camelCase string into camel-case (all lowercase with a "-" before the uppercase char)
 * @param text
 * @returns string
 */
export const slugifyCamelCase = (text: string) => text.replace(/[A-Z]/g, '-$&').toLowerCase();

/**
 * Coverts a PascalCase string into pascal-case (all lowercase with a "-" before the uppercase char but NOT the 1st one)
 * @param text
 * @returns string
 */
export const slugifyPascalCase = (text: string) => slugifyCamelCase(text).substring(1);
